import React, { useEffect, useRef, useState } from 'react';
import {
  mtCompanyDto,
  mtTagDto,
  PostDto,
  TagDtoList,
} from '../../../api/interfaces/Posts';
import {
  Controller,
  FieldError,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLoader } from '../../../Loader/LoaderContext';
import InputField from './InputField';
import TeaxtArea from './TeaxtArea';
import 'react-quill/dist/quill.snow.css'; // Quill editor styles
import Quill from 'quill';
import SelectTag from './SelectTag';
import ConfirmationModal from '../Modals/confirmationPopup';
import { API_ENDPOINTS } from '../../../api';
import AddEventConfirmationModal from './Modals/AddEventConfirmationModal';
import { mtCountryDto } from '../../../api/interfaces/addUser';
import {
  deleteService,
  getService,
  postService,
} from '../../../servce/ApisService';
// import { Select } from '@mui/material';
import { useToaster } from '../../../Toaster/Toaster';
import moment from 'moment';
import Sucesspopup from '../Modals/SucessPopup';
/* @ts-ignore */
import { AlignCenter, AlignLeft, AlignRight, Trash2 } from 'lucide-react';
import Select from 'react-select';
import {
  getDisplayCompany,
  getDisplayCompanys,
  getDisplayType,
} from '../../../utility/RolesUtility';
import { useUnsavedChanges } from '../Context/UnSavedChangesContext';
const Font = Quill.import('formats/font');
Font.whitelist = ['Inter']; // Add 'inter' to the whitelist
Quill.register(Font, true);

function AddEvents() {
  const [mtCompany, setMtCompany] = useState<mtCompanyDto[]>([]);
  const [isShow, setIsShow] = useState(false);
  const { showToast } = useToaster();
  const [totalPages, setTotalPages] = useState(false);
  const [isBollen, seTisBollen] = useState(false);
  const [mtTag, setMtTag] = useState<mtTagDto[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const menuRef = useRef<HTMLDivElement>(null);
  const [selectedContry, setSelectedContry] = useState<string>('');
  const [selectedTag, setSelectedTag] = useState<string>('');
  const [currentPages, setCurrentPages] = useState(0);
  const eventTypeOptions = [
    { value: '', label: 'Select  event Type' },
    { value: 'VIRTUAL', label: 'Virtual' },
    { value: 'VENUE', label: 'Venue' },
  ];
  const eventSectorOptions = [
    { value: '', label: 'Select  Sector' },
    { value: 'ROBOTICS', label: 'Robotics' },
    { value: 'AI', label: 'AI' },
  ];
  const eventCategoryOptions = [
    { value: '', label: 'Select Sector' },
    // {value:'HOSPITAL',label:'Hospital'},
    { value: 'IVF', label: 'IVF' },
    { value: 'IUI', label: 'IUI' },
    { value: 'SURROGACY_CENTER', label: 'Surrogacy Center' },
    { value: 'ICSI', label: 'ICSI' },
    { value: 'SPERM_OR_EGG_FREEZING', label: 'Sperm/ Egg freezing' },
    { value: 'ART', label: 'ART' },
  ];
  const [mtSector, setMtSector] = useState<mtTagDto[]>([]);
  const [selectedSector, setSelectedSector] = useState<number | null>(null);
  const today = new Date().toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(today); // Initialize startDate state
  const [endDate, setEndDate] = useState('');
  const [selectedDate, setSelectedDate] = useState(today);
  const [isPublish, setIsPublish] = useState(false);
  const [selectedRole, setSelectedRole] = useState<string | null>(null);
  const navigate = useNavigate();
  const quillRef = useRef<HTMLDivElement | null>(null);
  const quillInstance = useRef<Quill | null>(null);
  const [content, setContent] = useState<string>('');
  const [contentError, setContentError] = useState<string | null>(null); // Error state
  const [contentLength, setContentLength] = useState<number>(0);
  const { setLoading } = useLoader();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const quillInitialized = useRef(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [submittedData, setSubmittedData] = useState<PostDto | null>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    clearErrors,
    reset,
    getValues,
    setError,
    formState: { errors, isValid, isSubmitting, touchedFields, isDirty },
    setFocus,
  } = useForm<PostDto>({
    mode: 'onChange',
  });

  const selectedType = watch('type');
  const [isEditorFocused, setIsEditorFocused] = useState(false);

  const [selectedImage, setSelectedImage] = useState<HTMLImageElement | null>(
    null
  );
  const [imageToolbarPosition, setImageToolbarPosition] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    const toolbarSelects = document.querySelectorAll('.ql-toolbar select');
    toolbarSelects.forEach((select) => {
      select.addEventListener('mousedown', (e) => {
        e.stopPropagation(); // Prevent event from bubbling up
      });
    });

    return () => {
      toolbarSelects.forEach((select) => {
        select.removeEventListener('mousedown', (e) => {
          e.stopPropagation();
        });
      });
    };
  }, []);

  const [isResizing, setIsResizing] = useState(false);
  const resizeStartSize = useRef({ width: 0, height: 0 });
  const resizeStartPosition = useRef({ x: 0, y: 0 });

  // Add these functions inside the component
  const selectImage = (img: HTMLImageElement) => {
    if (quillRef.current) {
      quillRef.current.querySelectorAll('img').forEach((i) => {
        i.classList.remove('selected-image');
      });
    }

    img.classList.add('selected-image');
    setSelectedImage(img);

    const editorRect = quillRef.current?.getBoundingClientRect();
    const imgRect = img.getBoundingClientRect();

    if (editorRect) {
      setImageToolbarPosition({
        top: imgRect.top - editorRect.top - 50,
        left: imgRect.left - editorRect.left,
      });
    }
  };

  const startResize = (e: React.MouseEvent) => {
    if (!selectedImage) return;

    e.preventDefault();
    e.stopPropagation();

    setIsResizing(true);
    resizeStartSize.current = {
      width: selectedImage.offsetWidth,
      height: selectedImage.offsetHeight,
    };
    resizeStartPosition.current = {
      x: e.clientX,
      y: e.clientY,
    };

    const handleMouseMove = (e: MouseEvent) => {
      if (!selectedImage) return;

      const deltaX = e.clientX - resizeStartPosition.current.x;
      const newWidth = Math.max(50, resizeStartSize.current.width + deltaX);

      selectedImage.style.width = `${newWidth}px`;
      selectedImage.style.height = 'auto';
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      handleInput();
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  const alignImage = (alignment: string) => {
    if (!selectedImage) return;

    selectedImage.style.display = 'block';
    selectedImage.style.margin =
      alignment === 'center'
        ? '0 auto'
        : alignment === 'right'
        ? '0 0 0 auto'
        : '0 auto 0 0';

    handleInput();
  };

  const deleteImage = () => {
    if (!selectedImage) return;
    selectedImage.remove();
    setSelectedImage(null);
    handleInput();
  };

  const handleInput = () => {
    if (quillInstance.current) {
      const updatedContent = quillInstance.current.root.innerHTML;
      setContent(updatedContent);
    }
  };

  // Add this useEffect to handle clicks outside the image
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (
        selectedImage &&
        !target.closest('.image-toolbar') &&
        target.tagName !== 'IMG'
      ) {
        setSelectedImage(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [selectedImage]);

  const { hasUnsavedChanges, setHasUnsavedChanges, isWatched, setIsWatched } =
    useUnsavedChanges();

  const selectedEventType = watch('eventReqDto.type');
  const [formattedSize, setFormattedSize] = useState<string>('');
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<string | null>(null);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [assignToSubUsers, setAssignTo] = useState<any[]>([]); // State to manage added keywords
  const [keywordsInput, setKeywordsInput] = useState<string>(''); // Controlled input for new keyword entry
  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCountryId = e.target.value;
    console.log(selectedCountryId);

    setSelectedContry(selectedCountryId);

    const selectedCountry = mtContryData.find(
      (country: any) => country.id == selectedCountryId
    );
  };
  const handleTagChange = (selectedOptions: any) => {
    const selectedTagIds = selectedOptions.map((option: any) => option.value);
    setSelectedTags(selectedTagIds);

    // 👉 Sync with React Hook Form
    setValue(
      'tagDtoList',
      selectedTagIds.map((id: string) => ({ id: parseInt(id, 10) }))
    );

    // Clear error if at least one tag is selected
    if (selectedTagIds.length > 0) {
      clearErrors('tagDtoList');
    } else {
      setError('tagDtoList', {
        type: 'manual',
        message: 'At least one tag is required.',
      });
    }
  };
  const handleMenuScrollToBottomForSector = async () => {
    try {
      console.log('Scrolled to the bottom of the tags dropdown');

      // Determine the appropriate API endpoint based on user roles
      let url = '';
      url = API_ENDPOINTS.getSectorChief;

      const body = {
        page: currentPages + 1, // Increment the current page for pagination
        search: searchQuery,
        // isAllData: true,
      };

      const response = await postService(url, body);
      console.log('API response for additional tags:', response.data);

      const newTags = response.data.content; // Access the array within the 'content' property
      if (Array.isArray(newTags)) {
        setMtSector((prevTags) => [...prevTags, ...newTags]); // Append new tags to existing tags
        setCurrentPages((prevPage) => prevPage + 1); // Update current page for subsequent requests
      } else {
        console.error('Expected an array but received:', newTags);
      }
    } catch (error) {
      console.error('Error fetching more tags:', error);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Function to handle adding a keyword
  const addKeyword = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (
      (event.key === 'Enter') &&
      keywordsInput.trim() !== ''
    ) {
      const keywordArray = keywordsInput
        .split(',') // Split by comma or hyphen
        .map((kw) => kw.trim())
        .filter((kw) => /^[a-zA-Z0-9\s]+$/.test(kw)); // Ensure only alphanumeric characters and spaces

        
      const uniqueNewKeywords = keywordArray.filter(
        (kw) => !assignToSubUsers.includes(kw) && kw.length > 0
      ); // Filter unique keywords and prevent empty strings

      if (
        uniqueNewKeywords.length > 0 &&
        assignToSubUsers.length + uniqueNewKeywords.length <= 10
      ) {
        const updatedTags = [...assignToSubUsers, ...uniqueNewKeywords]; // Add unique keywords to tag list
        setAssignTo(updatedTags); // Update local tags state
        setKeywordsInput(''); // Clear input
        setValue('keyWords', updatedTags.join(',')); // Update form state as comma-separated string
        clearErrors('keyWords');
      }else{
        setError('keyWords', {
          type: 'manual',
          message: `Only 10 keywords are allowed (${assignToSubUsers.length}/10)`
        });
      }
    }
  };
  const fetchSectpr = async () => {
    setLoading(true);
    let body: any = {
      page: currentPages,
      search: searchQuery,
      // isAllData: false,
    };
    try {
      let url = '';
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getSectorChief;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getSectorJunior;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getSectorUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getSectorPub;
      }
      const response = await postService(url, body);
      const tagData = response.data.content; // Change this to response.data.content

      if (Array.isArray(tagData)) {
        setMtSector(tagData);
      } else {
        console.error('Expected an array but received:', tagData);
      }
    } catch (error) {
      console.error('Error fetching tags:', error);
      setMtSector([]);
    } finally {
      setLoading(false);
    }
  };
  const handleMenuScrollToBottomForTags = async () => {
    try {
      console.log('Scrolled to the bottom of the tags dropdown');

      // Determine the appropriate API endpoint based on user roles
      let url = '';
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getTagChief;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getTagJunior;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getTagUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getTagPub;
      }

      const body = {
        page: currentPage + 1, // Increment the current page for pagination
        search: searchQuery,
        isAllData: true,
      };

      const response = await postService(url, body);
      console.log('API response for additional tags:', response.data);

      const newTags = response.data.content; // Access the array within the 'content' property
      if (Array.isArray(newTags)) {
        setMtTag((prevTags) => [...prevTags, ...newTags]); // Append new tags to existing tags
        setCurrentPage((prevPage) => prevPage + 1); // Update current page for subsequent requests
      } else {
        console.error('Expected an array but received:', newTags);
      }
    } catch (error) {
      console.error('Error fetching more tags:', error);
    }
  };
  const mtCountryDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.countryData);
      console.log(response);
      setMtCountry(response.data);
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const mtTagDtoData = async (input: string) => {
    setLoading(true);
    try {
      let url = '';
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getTagChief;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getTagJunior;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getTagUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getTagPub;
      }
      const body = {
        page: currentPage,
        search: searchQuery,
        isAllData: true,
      };
      const response = await postService(url, body);
      console.log('API response data:', response.data); // Log API response

      // Access the array within the 'content' property
      const tagData = response.data.content; // Change this to response.data.content

      if (Array.isArray(tagData)) {
        setMtTag(tagData);
      } else {
        console.error('Expected an array but received:', tagData);
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setLoading(false);
    }
  };
  const getUniqueUsers = (users: any[]) => {
    const seen = new Set();
    return users.filter((user) => {
      if (seen.has(user.appUserId)) return false;
      seen.add(user.appUserId);
      return true;
    });
  };
  const [hasMore, setHasMore] = useState(true); // Flag to stop fetching if no more data
  const [loading, setLoadings] = useState(false);
  useEffect(() => {
    // Load country and continent data on component mount
    const loadInitialData = async () => {
      await mtCompanyDtoData();
      // setMtCountryDataLoaded(true);
    };

    loadInitialData();
  }, []);
  const [page, setPage] = useState(0);
  const mtCompanyDtoData = async () => {
    setLoading(true);
    try {
      const body = {
        page: page,
        search: searchQuery,
        filter: 'EVENT',
        // companyTypeList:['EVENT']
        // isAllData:true
      };

      let url = '';
      if (userInfo.roles === 'CHIEF_EDITOR') {
        url = API_ENDPOINTS.getCompanyCheif;
      } else if (userInfo.roles === 'JUNIOR_EDITOR') {
        url = API_ENDPOINTS.getCompanyJunior;
      } else if (userInfo.roles === 'UPLOADER') {
        url = API_ENDPOINTS.getCompanyUploader;
      } else if (userInfo.roles === 'PUBLISHER') {
        url = API_ENDPOINTS.getCompanyPublisher;
      }

      const response = await postService(API_ENDPOINTS.getCompany, body);
      console.log('API response data:', response.data); // Log API response

      // Access the array within the 'content' property
      const companyData = response.data.content; // Change this to response.data.content

      if (Array.isArray(companyData)) {
        const isFirstPage = page === 1;

        const newList = isFirstPage ? [...companyData] : companyData;

        setMtCompany((prevCompanies) => {
          const combined = [...prevCompanies, ...newList];

          // Deduplicate by 'id'
          const uniqueMap = new Map();
          combined.forEach((item) => uniqueMap.set(item.id, item));

          return Array.from(uniqueMap.values());
        });

        // If returned data is empty or less than expected, stop fetching
        if (companyData.length === 0) {
          setHasMore(false);
        } else {
          if (!response?.data?.last) {
            // setPage((prevPage) => prevPage + 1); // Move to next page
          }
        }
      } else {
        console.error('Expected an array but received:', companyData);
        setHasMore(false);
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClosePopup = () => setIsPopupOpen(false);
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setStartDate(selectedDate); // Update start date
    const nextDay = new Date(selectedDate);
    nextDay.setDate(nextDay.getDate()); // Set next day after the selected start date
    setEndDate(nextDay.toISOString().split('T')[0]); // Update end date state to be the next day
  };
  const handleDateClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault(); // Prevent default click action if needed
    e.currentTarget.showPicker(); // Re-focus to trigger the date picker again
  };
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDate(e.target.value);
    // setValue("bookingDate", e.target.value); // Set value in React Hook Form
  };
  useEffect(() => {
    if (userId && quillRef.current && !quillInitialized.current) {
      initializeQuill();

      // Now attach focus/blur listeners
      const quill = quillInstance.current!;

      const handleFocus = () => {
        setIsEditorFocused(true);
      };

      const handleBlur = () => {
        setIsEditorFocused(false);
      };

      quill.on('selection-change', (range) => {
        if (range !== null) {
          setIsEditorFocused(true);
        } else {
          setIsEditorFocused(false);
        }
      });

      return () => {
        quill.off('selection-change', handleFocus);
      };
    }
  }, [userId, quillRef]);

  const initializeQuill = () => {
    if (quillRef.current && !quillInstance.current) {
      // Register a custom break blot for soft line breaks
      const Break = Quill.import('blots/break');
      const Embed = Quill.import('blots/embed');

      class SoftBreak extends Embed {
        static create() {
          return document.createElement('br');
        }

        static value() {
          return undefined;
        }
      }

      SoftBreak.blotName = 'break';
      SoftBreak.tagName = 'BR';

      Quill.register(SoftBreak);

      // Ensure video blot is registered (add this section)
      const Video = Quill.import('formats/video');
      if (Video) {
        Quill.register(Video);
      }

      quillInstance.current = new Quill(quillRef.current, {
        theme: 'snow',
        bounds: quillRef.current,
        scrollingContainer: quillRef.current,
        modules: {
          toolbar: [
            [{ font: Font.whitelist }],
            [{ size: [] }],
            [{ header: [1, 2, 3] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link', 'image', 'video'],
            [{ color: [] }, { background: [] }],
            ['clean'],
          ],
          keyboard: {
            bindings: {
              shift_enter: {
                key: 'Enter',
                shiftKey: true,
                handler: function (range: any) {
                  const quill = quillInstance.current;
                  if (!quill) return true;

                  // Get current selection, ensuring we have a valid range
                  let currentRange = range || quill.getSelection();
                  if (!currentRange) {
                    // Force focus and get selection again
                    quill.focus();
                    currentRange = quill.getSelection();
                    if (!currentRange) {
                      return true; // Let default behavior handle it
                    }
                  }

                  const format = quill.getFormat(currentRange.index);

                  if (format?.list) {
                    // For lists, insert a break element for soft line break
                    quill.insertEmbed(
                      currentRange.index,
                      'break',
                      true,
                      'user'
                    );
                    quill.setSelection(currentRange.index + 1, 0, 'user');
                  } else {
                    // For regular text, insert a newline
                    quill.insertText(currentRange.index, '\n', 'user');
                    quill.setSelection(currentRange.index + 1, 0, 'user');
                  }

                  return false; // Prevent default Enter behavior
                },
              },
              list_backspace: {
                key: 'Backspace',
                collapsed: true,
                format: ['list'],
                offset: 1,
                handler: function (range: any, context: any) {
                  if (context.format.list) {
                    const [line, offset] =
                      quillInstance.current?.getLine(range.index) || [];
                    if (
                      line &&
                      offset === 0 &&
                      line.domNode.firstChild?.nodeName === 'BR'
                    ) {
                      quillInstance.current?.format('list', false, 'user');
                      return;
                    }
                  }
                  quillInstance.current?.deleteText(range.index - 1, 1, 'user');
                },
              },
            },
          },
        },
        placeholder: 'Start typing...',
      });

      quillInstance.current.format('font', 'Inter');

      // CRITICAL: Set the font picker to show "Inter" as selected
      const setFontPickerDefault = () => {
        const fontPicker = document.querySelector('.ql-font .ql-picker-label');
        if (fontPicker) {
          // Set the data-value attribute
          fontPicker.setAttribute('data-value', 'Inter');

          // Use the proper Quill format - preserve the colon prefix
          fontPicker.textContent = ': Inter';
        }
      };
      // Apply the default selection after a brief delay to ensure DOM is ready
      setTimeout(setFontPickerDefault, 100);
      // Custom link tooltip implementation
      let customTooltip: HTMLDivElement | null = null;
      let currentLinkElement: HTMLAnchorElement | null = null;

      const createCustomTooltip = () => {
        if (customTooltip) return customTooltip;

        customTooltip = document.createElement('div');
        customTooltip.className = 'custom-link-tooltip';
        customTooltip.style.cssText = `
        position: absolute;
        background: #333;
        color: white;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 12px;
        z-index: 1000;
        display: none;
        white-space: nowrap;
        box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        max-width: 300px;
        word-break: break-all;
      `;

        const linkText = document.createElement('span');
        linkText.style.cssText = `
        margin-right: 8px;
        display: none !important;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
     
        vertical-align: middle;
      `;

        const editBtn = document.createElement('button');
        editBtn.textContent = 'Edit';
        editBtn.style.cssText = `
        background: #007bff;
        color: white;
        border: none;
        padding: 2px 8px;
        border-radius: 3px;
        cursor: pointer;
        font-size: 11px;
        margin-right: 4px;
      `;

        const removeBtn = document.createElement('button');
        removeBtn.textContent = 'Remove';
        removeBtn.style.cssText = `
        background: #dc3545;
        color: white;
        border: none;
        padding: 2px 8px;
        border-radius: 3px;
        cursor: pointer;
        display: none;
        font-size: 11px;
        margin-right: 4px;
      `;

        const visitBtn = document.createElement('button');
        visitBtn.textContent = 'Visit';
        visitBtn.style.cssText = `
        background: #28a745;
        color: white;
        border: none;
        padding: 2px 8px;
        border-radius: 3px;
        cursor: pointer;
        font-size: 11px;
      `;

        customTooltip.appendChild(linkText);
        customTooltip.appendChild(editBtn);
        customTooltip.appendChild(removeBtn);
        customTooltip.appendChild(visitBtn);

        editBtn.addEventListener('click', () => {
          if (currentLinkElement) {
            const newUrl = prompt('Enter new URL:', currentLinkElement.href);
            if (newUrl && newUrl.trim()) {
              currentLinkElement.href = newUrl.trim();
              hideCustomTooltip();
            }
          }
        });

        removeBtn.addEventListener('click', () => {
          if (currentLinkElement && quillInstance.current) {
            const range = quillInstance.current.getSelection();
            if (range) {
              const [leaf] = quillInstance.current.getLeaf(range.index);
              if (leaf && leaf.domNode.parentNode === currentLinkElement) {
                quillInstance.current.formatText(
                  range.index,
                  range.length,
                  'link',
                  false
                );
              }
            }
            hideCustomTooltip();
          }
        });

        visitBtn.addEventListener('click', () => {
          if (currentLinkElement) {
            window.open(currentLinkElement.href, '_blank');
            hideCustomTooltip();
          }
        });

        document.body.appendChild(customTooltip);
        return customTooltip;
      };

      const showCustomTooltip = (
        linkElement: HTMLAnchorElement,
        x: number,
        y: number
      ) => {
        const tooltip = createCustomTooltip();
        if (!tooltip) return;

        currentLinkElement = linkElement;
        const linkText = tooltip.querySelector('span') as HTMLSpanElement;
        linkText.textContent = linkElement.href;
        linkText.title = linkElement.href;

        const editorRect = quillRef.current?.getBoundingClientRect();
        if (editorRect) {
          let left = x;
          let top = y - 40;

          tooltip.style.display = 'block';
          const tooltipRect = tooltip.getBoundingClientRect();

          if (left + tooltipRect.width > editorRect.right) {
            left = editorRect.right - tooltipRect.width - 10;
          }
          if (left < editorRect.left) {
            left = editorRect.left + 10;
          }
          if (top < editorRect.top) {
            top = y + 20;
          }

          tooltip.style.left = `${left}px`;
          tooltip.style.top = `${top}px`;
          tooltip.style.display = 'block';
        }
      };

      const hideCustomTooltip = () => {
        if (customTooltip) {
          customTooltip.style.display = 'none';
          currentLinkElement = null;
        }
      };

      const hideDefaultTooltip = () => {
        const defaultTooltip =
          document.querySelector<HTMLElement>('.ql-tooltip');
        if (defaultTooltip) {
          defaultTooltip.style.display = 'none';
        }
      };

      // Custom link handler
      const linkHandler = () => {
        const range = quillInstance.current?.getSelection();
        if (!range) return;

        const text =
          quillInstance.current?.getText(range.index, range.length) || '';
        const url = prompt('Enter the URL:', 'https://');
        if (url) {
          quillInstance.current?.formatText(
            range.index,
            range.length,
            'link',
            url
          );
        }
      };

      // Custom video handler - ADD THIS SECTION
      const videoHandler = () => {
        const range = quillInstance.current?.getSelection();
        if (!range) return;

        const url = prompt(
          'Enter video URL (YouTube, Vimeo, etc.):',
          'https://'
        );
        if (url && url.trim()) {
          // Convert YouTube/Vimeo URLs to embed format
          let embedUrl = url.trim();

          // YouTube URL conversion
          if (embedUrl.includes('youtube.com/watch?v=')) {
            const videoId = embedUrl.split('v=')[1].split('&')[0];
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          } else if (embedUrl.includes('youtu.be/')) {
            const videoId = embedUrl.split('youtu.be/')[1].split('?')[0];
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          }

          // Vimeo URL conversion
          else if (embedUrl.includes('vimeo.com/')) {
            const videoId = embedUrl.split('vimeo.com/')[1].split('?')[0];
            embedUrl = `https://player.vimeo.com/video/${videoId}`;
          }

          // Insert the video
          quillInstance.current?.insertEmbed(
            range.index,
            'video',
            embedUrl,
            'user'
          );
          quillInstance.current?.setSelection(range.index + 1, 0, 'user');
        }
      };

      const toolbar = quillInstance.current.getModule('toolbar');
      toolbar.addHandler('link', linkHandler);
      toolbar.addHandler('video', videoHandler); // ADD THIS LINE

      // Handle clicks in the editor
      quillRef.current.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;

        // Handle image clicks
        if (target.tagName === 'IMG') {
          e.preventDefault();
          e.stopPropagation();
          selectImage(target as HTMLImageElement);
          return;
        }

        // Handle video clicks - ADD THIS SECTION
        if (target.tagName === 'IFRAME') {
          e.preventDefault();
          e.stopPropagation();
          // You can add custom video editing logic here if needed
          return;
        }

        // Handle link clicks
        if (target.tagName === 'A') {
          e.preventDefault();
          e.stopPropagation();
          hideDefaultTooltip();
          showCustomTooltip(target as HTMLAnchorElement, e.clientX, e.clientY);
          return;
        }

        hideCustomTooltip();
      });

      // Hide tooltip when clicking outside the editor
      document.addEventListener('click', (e) => {
        if (
          !quillRef.current?.contains(e.target as Node) &&
          !customTooltip?.contains(e.target as Node)
        ) {
          hideCustomTooltip();
        }
      });

      // Hide tooltip on scroll
      quillRef.current.addEventListener('scroll', () => {
        hideCustomTooltip();
      });

      // Text change handlers
      quillInstance.current.on('text-change', () => {
        hideCustomTooltip();
        hideDefaultTooltip();

        // const lists = quillInstance.current?.root.querySelectorAll('ol');
        // lists?.forEach((ol, index) => {
        //   ol.style.counterReset = `list-item ${index}`;
        // });

        if (quillInstance.current) {
          const updatedContent = quillInstance.current.root.innerHTML;
          setContent(updatedContent);
          const plainTextContent = quillInstance.current.getText();
          validateContentLength(plainTextContent);
        }
      });

      // Selection change handler
      quillInstance.current.on('selection-change', (range) => {
        if (range) {
          const format = quillInstance.current?.getFormat(range);
          if (!format?.link) {
            hideCustomTooltip();
            setFontPickerDefault();
          }
        } else {
          hideCustomTooltip();
        }
      });

      // Add tooltips to toolbar buttons
      const toolbars = quillInstance.current.getModule('toolbar');

      const buttons = toolbars.container.querySelectorAll('button, select');

      buttons.forEach((button: HTMLButtonElement | HTMLSelectElement) => {
        if (button.tagName === 'BUTTON') {
          const format = button.classList[0]?.split('-')[1];
          switch (format) {
            case 'bold':
              button.title = 'Bold (Ctrl+B)';
              break;
            case 'italic':
              button.title = 'Italic (Ctrl+I)';
              break;
            case 'underline':
              button.title = 'Underline (Ctrl+U)';
              break;
            case 'strike':
              button.title = 'Strikethrough';
              break;
            case 'blockquote':
              button.title = 'Blockquote';
              break;
            case 'ordered':
              button.title = 'Ordered List';
              break;
            case 'bullet':
              button.title = 'Bullet List';
              break;
            case 'link':
              button.title = 'Insert Link';
              break;
            case 'image':
              button.title = 'Insert Image';
              break;
            case 'video':
              button.title = 'Insert Video';
              break;
            case 'clean':
              button.title = 'Remove Formatting';
              break;
            default:
              break;
          }
        } else if (button.tagName === 'SELECT') {
          if (button.classList.contains('ql-header')) {
            button.title = 'Header';
          } else if (button.classList.contains('ql-font')) {
            button.title = 'Font';
          } else if (button.classList.contains('ql-size')) {
            button.title = 'Font Size';
          } else if (button.classList.contains('ql-color')) {
            button.title = 'Text Color';
          } else if (button.classList.contains('ql-background')) {
            button.title = 'Background Color';
          } else if (button.classList.contains('ql-list')) {
            button.title =
              button.value === 'ordered' ? 'Ordered List' : 'Bullet List';
          }
        }
      });

      // Font styling
      const interItem = document.querySelector(
        '.ql-picker-item[data-value="Inter"]'
      ) as HTMLElement;
      if (interItem) {
        interItem.style.fontFamily = "'Inter', sans-serif";
      }

      const sansSerifItem = document.querySelector(
        '.ql-picker-item[data-value="serif"]'
      ) as HTMLElement;
      if (sansSerifItem) {
        sansSerifItem.style.fontFamily = 'sans-serif';
      }

      quillInstance.current.format('font', 'Inter');
      quillInitialized.current = true;
      updateFontItemStyles();

      toolbar.addHandler('font', (value: string) => {
        if (value) {
          quillInstance.current?.format('font', value);
          updateFontPicker(value);
        }
      });

      const currentFont = quillInstance.current.getFormat().font;
      updateFontPicker(currentFont || '');

      // Cleanup function
      return () => {
        if (customTooltip) {
          document.body.removeChild(customTooltip);
        }
      };
    }
  };

  const validateContentLength = (text: string) => {
    const contentLength = text.trim().length;
    if (contentLength === 0) {
      if (isPublish) {
        setContentError('Content is required.');
      }
      // Empty content is invalid
    } else if (contentLength < 300) {
      setContentError('Content must be at least 300 characters.');
    } else if (contentLength > 10000) {
      setContentError('Content must not exceed 10,000 characters.');
    } else {
      setContentError(null); // Valid content
    }
  };
  const handleTextChange = () => {
    if (quillInstance.current) {
      const updatedContent = quillInstance.current.root.innerHTML;
      setContent(updatedContent);

      const plainTextContent = quillInstance.current.getText();
      setContentLength(plainTextContent.trim().length);
    }
  };
  useEffect(() => {
    mtCountryDtoData();
    fetchSectpr();
    mtTagDtoData(searchQuery);
    if (userId) {
      fetchVehicles();
    }

    // Initialize Quill
    initializeQuill();

    const quill = quillInstance.current;
    if (!quill) return;

    // 👉 Add selection-change listener to track focus
    const handleSelectionChange = (range: any) => {
      if (range !== null) {
        setIsEditorFocused(true);
      } else {
        setIsEditorFocused(false);
      }
    };

    quill.on('selection-change', handleSelectionChange);

    // Optional: You can also listen to text-change as secondary signal
    quill.on('text-change', handleTextChange);

    // Cleanup
    return () => {
      quill.off('selection-change', handleSelectionChange);
      quill.off('text-change', handleTextChange);
    };
  }, []);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      let url: string;

      // Assign API endpoint based on user role
      switch (userInfo.roles) {
        case 'CHIEF_EDITOR':
          url = `${API_ENDPOINTS.getPostsDetailsCheif}?id=${userId}`;
          break;
        case 'JUNIOR_EDITOR':
          url = `${API_ENDPOINTS.getPostsDetails}?id=${userId}`;
          break;
        case 'UPLOADER':
          url = `${API_ENDPOINTS.getPostsDetailsUploader}?id=${userId}`;
          break;
        case 'PUBLISHER':
          url = `${API_ENDPOINTS.getPostsDetailsPublisher}?id=${userId}`;
          break;
        default:
          throw new Error('Unknown role');
      }

      const response = await getService(url);

      // Handle keywords if they exist
      const keywords = response.data.keyWords || '';
      const fetchedKeywords = keywords
        .split(',')
        .map((kw: string) => kw.trim())
        .filter((kw: any) => kw);
      setAssignTo(fetchedKeywords);

      // Format the data for the form
      const formattedData = {
        ...response.data,
        tagDtoList: response.data.tagDtoList || [],
        eventReqDto: response.data.eventReqDto
          ? {
              ...response.data.eventReqDto,
              startDate: response.data.eventReqDto.startDate
                ? moment(
                    response.data.eventReqDto.startDate,
                    'DD/MM/YYYY'
                  ).format('YYYY-MM-DD')
                : '',
              endDate: response.data.eventReqDto.endDate
                ? moment(
                    response.data.eventReqDto.endDate,
                    'DD/MM/YYYY'
                  ).format('YYYY-MM-DD')
                : '',
              mtCountryDto: response.data.eventReqDto.mtCountryDto || null,
            }
          : null,
      };

      // Update state with the fetched data
      setSubmittedData(formattedData);
      setSelectedSector(response.data?.sectorDto?.id || null);
      const initialTags =
        response.data.tagDtoList
          ?.filter((tag: any) => tag.id != null)
          .map((tag: any) => tag.id.toString()) || [];
      setSelectedTags(initialTags);
      // Reset form with the formatted data
      reset(formattedData);

      // Set Quill editor content if it exists
      if (quillInstance.current && response.data.actualContent) {
        quillInstance.current.root.innerHTML = response.data.actualContent;
        setContent(response.data.actualContent);
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (submittedData) {
      // Reset the form with the fetched data
      reset({
        ...submittedData,
        companyName: submittedData.companyRespDto?.name || '',
        companyId: submittedData.companyRespDto?.id || null,
        recordType: submittedData.companyRespDto?.recordType || undefined,
      });

      // Set selected tags if they exist
      if (submittedData.tagDtoList && submittedData.tagDtoList.length > 0) {
        const initialTags = submittedData.tagDtoList
          .filter((tag) => tag.id !== null)
          .map((tag) => tag.id.toString());
        setSelectedTags(initialTags);
      }
    }
  }, [submittedData, reset, setValue]);

  const updateFontItemStyles = () => {
    const fontItems = ['inter', 'sans-serif', 'monospace'];
    fontItems.forEach((font) => {
      const fontItem = document.querySelector(
        `.ql-picker-item[data-value="${font}"]`
      ) as HTMLElement;
      if (fontItem) {
        fontItem.style.fontFamily = `'${font}', sans-serif`; // Apply custom font styles
      }
    });
  };

  const updateFontPicker = (value: string) => {
    const fontItems = document.querySelectorAll('.ql-picker-item');
    fontItems.forEach((item) => {
      if (item instanceof HTMLElement) {
        if (item.getAttribute('data-value') === value) {
          item.classList.add('ql-selected'); // Highlight the selected item
        } else {
          item.classList.remove('ql-selected'); // Remove highlight from others
        }
      }
    });

    // Update the label in the dropdown to reflect the selected font
    const fontLabel = document.querySelector('.ql-picker-label') as HTMLElement;
    if (fontLabel) {
      // Set the label to the selected font directly without any prefix
      fontLabel.textContent = ' : ' + value; // Set label to selected font only
    }
  };
  // Handle removing a keyword
  const removeKeyword = (keyword: string) => {
    const updatedTags = assignToSubUsers.filter((tag) => tag !== keyword);
    setAssignTo(updatedTags);
    setValue('keyWords', updatedTags.join(',')); // Update form state
  };
  const formatFileSize = (size: number): string => {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
  };
  const clearFile = () => {
    setFile(null);
    if (userId) {
      submitDeleteTag();
    }
  };
  const submitDeleteTag = async () => {
    handleClosePopup();
    setLoading(true);
    setLoading(true);
    let url = '';
    if (userInfo.roles === 'CHIEF_EDITOR') {
      url = API_ENDPOINTS.deleteCEImage;
    } else if (userInfo.roles === 'JUNIOR_EDITOR') {
      url = API_ENDPOINTS.deleteUserJEImage;
    } else if (userInfo.roles === 'UPLOADER') {
      url = API_ENDPOINTS.deleteUserUpImage;
    } else if (userInfo.roles === 'PUBLISHER') {
      url = API_ENDPOINTS.deleteUserPublisherImage;
    }
    try {
      let response: any;

      response = await deleteService(url + '?postId=' + userId);

      if (response.statusCode == 200) {
        fetchVehicles();
        showToast('Image deleted successfully!', 'success', '');
      }
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (inputValue: string) => {
    setSearchQuery(inputValue);
    setCurrentPage(0); // Reset page
    mtTagDtoData(inputValue); // Fetch filtered data
  };
  const handleMenuScrollToBottoms = async () => {
    setLoading(true);
    try {
      let url = '';
      let payload = {
        search: '',
        page: page,
        filter: 'EVENT',
      };

      const response = await postService(API_ENDPOINTS.getCompany, payload);
      console.log('API response data:', response.data); // Log API response

      // Access the array within the 'content' property
      const companyData = response.data.content; // Change this to response.data.content

      if (Array.isArray(companyData)) {
        const isFirstPage = page === 0;

        const newList = isFirstPage ? [...companyData] : companyData;

        setMtCompany((prevCompanies) => {
          const combined = [...prevCompanies, ...newList];

          // Deduplicate by 'id'
          const uniqueMap = new Map();
          combined.forEach((item) => uniqueMap.set(item.id, item));

          return Array.from(uniqueMap.values());
        });

        // If returned data is empty or less than expected, stop fetching
        if (companyData.length === 0) {
          setHasMore(false);
        } else {
          if (!response?.data?.last) {
            setPage((prevPage) => prevPage + 1); // Move to next page
          }
        }
      } else {
        console.error('Expected an array but received:', companyData);
        setHasMore(false);
      }
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleMenuScrollToBottom = () => {
    if (!totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      mtTagDtoData(searchQuery);
    }
  };
  const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      await handleFileChange(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleFileChange = async (file: File) => {
    if (file) {
      const selectedFile = file;
      console.log(selectedFile);
      const formattedSize = formatFileSize(selectedFile.size);
      setFormattedSize(formattedSize);
      setSelectedFile(selectedFile);
      // Convert the file to a Base64 string
      const preview = await convertToBase64(selectedFile);
      setFile(preview);
      if (!preview) {
        setError('imageDto', {
          type: 'manual',
          message: 'Image is required.',
        });
        return; // Stop form submission if no image is uploaded
      } else {
        clearErrors();
      }
    }
  };

  useEffect(() => {
    // Set a timeout to ensure the input is rendered before setting focus
    const timeoutId = setTimeout(() => {
      console.log('Setting focus to title');
      setFocus('title');
    }, 100); // Adjust the timeout duration if necessary

    // Cleanup the timeout on unmount
    return () => clearTimeout(timeoutId);
  }, [setFocus]);

  const handleFileInputClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };
  const handleSendForApproval = (role: string) => {
    setIsPublish(true);
    setSelectedRole(role);
    // if (isPublish) {
    let hasError = false;
    const plainTextContent = quillInstance.current?.getText().trim() || ''; // Get plain text content without HTML tags
    const contentLength: number = plainTextContent?.length;
    if (!plainTextContent) {
      setContentError('Actual Content is required'); // Show error if content is empty
      hasError = true;
    } else if (contentLength < 300) {
      setContentError('Content must be at least 300 characters long.');
      hasError = true;
    } else if (contentLength > 25000) {
      setContentError('Content cannot exceed 25,000 characters.');
      hasError = true;
    } else {
      setContentError(null); // Clear content error if valid
    }
    // }
    if (!file && !submittedData?.imageDto?.documentUrl && isPublish) {
      setError('imageDto', {
        type: 'manual',
        message: 'Image is required.',
      });
      hasError = true; // Stop form submission if no image is uploaded
    }
    if (!selectedTags?.length) {
      setError('tagDtoList', {
        type: 'manual',
        message: 'At least one tag is required.',
      });
      hasError = true;
    } else {
      clearErrors();
    }
    if (hasError) {
      return;
    }
    handleSubmit(onSubmit);
  };

  const handleSaveDraft = () => {
    setIsPublish(false);
    clearErrors(); // Clear react-hook-form errors
    setContentError(null); // Clear manual content error

    // Get the current values
    const titleValue = watch('title')?.trim() || '';
    const descriptionValue = watch('description')?.trim() || '';

    let hasError = false;

    // Validate only for draft: Title and Description
    if (titleValue.length === 0) {
      setError('title', {
        type: 'manual',
        message: 'Event name is required.',
      });
      hasError = true;
    } else if (titleValue.length < 5) {
      setError('title', {
        type: 'manual',
        message: 'Event name must be at least 5 characters.',
      });
      hasError = true;
    }

    if (descriptionValue.length === 0) {
      setError('description', {
        type: 'manual',
        message: 'Description is required.',
      });
      hasError = true;
    } else if (descriptionValue.length < 100) {
      setError('description', {
        type: 'manual',
        message: 'Description must be at least 100 characters.',
      });
      hasError = true;
    }

    // If there are no errors, proceed to open the confirmation modal
    if (!hasError) {
      // 1. Manually gather the form data
      const draftData = getValues(); // This gets all form values from react-hook-form

      // 2. Set the data to be submitted
      setSubmittedData(draftData); // This is the data your `handleConfirm` will use

      // 3. Open the confirmation modal directly
      handleOpenPopup(); // or setIsPopupOpen(true);
    }
    // If hasError is true, the function ends, and the modal does not open.
  };
  const closePopup = () => {
    setIsShow(false);

    console.log('Popup closed:', isPopupOpen);
    setTimeout(() => {
      navigate('/portals/posts/addEvents');
      window.location.reload();
    }, 500);
    // setHasUnsavedChanges(false);
  };
  const viewUsers = () => {
    setIsShow(false);
    navigate('/portals/posts/viewEventsPosts');
  };
  useEffect(() => {
    if (submittedData?.eventReqDto?.link) {
      setValue('eventReqDto.link', submittedData?.eventReqDto?.link);
    }
  }, [submittedData, setValue]);

  const handleConfirm = async () => {
    handleClosePopup();
    setLoading(true);

    try {
      // Validate submitted data exists
      if (!submittedData) {
        showToast(
          'Error: No data to submit',
          'error',
          'Please provide the necessary data.'
        );
        setLoading(false);
        return;
      }

      // Determine status based on role and publish state
      let status;
      if (isPublish) {
        switch (userInfo.roles) {
          case 'PUBLISHER':
            status = 'PUBLISHED';
            break;
          case 'CHIEF_EDITOR':
            status = 'TO_PUBLISHER_APPROVE';
            break;
          case 'JUNIOR_EDITOR':
            status =
              selectedRole === 'CE' ? 'TO_CE_APPROVE' : 'TO_PUBLISHER_APPROVE';
            break;
          case 'UPLOADER':
            status =
              selectedRole === 'JE'
                ? 'TO_JE_APPROVE'
                : selectedRole === 'CE'
                ? 'TO_CE_APPROVE'
                : 'TO_PUBLISHER_APPROVE';
            break;
          default:
            status = 'TO_PUBLISHER_APPROVE';
        }
      } else {
        status = 'SAVED_AS_DRAFT';
      }

      // Prepare payload with guaranteed defaults
      const eventReq = submittedData?.eventReqDto || {};
      const payload: any = {
        title: submittedData?.title || '',
        tagDtoList: selectedTags.map((id) => ({ id: parseInt(id, 10) })),
        description: submittedData?.description || '',
        sectorId: selectedSector,
        imageCaption: submittedData?.imageCaption || '',
        seoMetaTitle: submittedData?.seoMetaTitle || '',
        seoDescription: submittedData?.seoDescription || '',
        seoAltText: submittedData?.seoAltText || '',
        category: submittedData?.category || '',
        imageDto: selectedFile
          ? {
              name: selectedFile.name,
              type: selectedFile.type,
              base64Str: file,
            }
          : null,
        actualContent: content,
        keyWords: submittedData?.keyWords || keywordsInput || '',
        isPublish,
        status,
        companyRespDto: {
          id: submittedData?.companyId || null,
          recordType: submittedData?.recordType || null,
        },
        // Always include eventReqDto with guaranteed VIRTUAL default
        eventReqDto: {
          startDate: eventReq.startDate
            ? moment(eventReq.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : null,
          endDate: eventReq.endDate
            ? moment(eventReq.endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : null,
          // mtCountryDto: {
          //   id: eventReq.mtCountryDto?.id
          //     ? parseInt(eventReq.mtCountryDto.id as unknown as string, 10)
          //     : selectedContry || null,
          // },
          mtCountryDto: {
            id:
              (eventReq.mtCountryDto?.id as any) === 'select'
                ? null
                : eventReq.mtCountryDto?.id
                ? parseInt(eventReq.mtCountryDto.id as unknown as string, 10)
                : selectedContry || null,
          },
          venue: eventReq.venue || null,
          type: eventReq.type ? eventReq.type : 'VIRTUAL', // Guaranteed default
          link: eventReq.link || null,
        },
      };

      // Determine endpoint and make API call
      let response;
      if (userId) {
        payload.id = parseInt(userId, 10);

        let endpoint;
        switch (userInfo.roles) {
          case 'CHIEF_EDITOR':
            endpoint = API_ENDPOINTS.updateEventForCE;
            break;
          case 'JUNIOR_EDITOR':
            endpoint = API_ENDPOINTS.updateEventForJE;
            break;
          case 'UPLOADER':
            endpoint = API_ENDPOINTS.updateEventForUploader;
            break;
          case 'PUBLISHER':
            endpoint = API_ENDPOINTS.updateEventForPub;
            break;
          default:
            throw new Error('Unsupported role');
        }

        response = await postService(endpoint, payload);
      } else {
        let endpoint;
        switch (userInfo.roles) {
          case 'CHIEF_EDITOR':
            endpoint = API_ENDPOINTS.addEventForCE;
            break;
          case 'JUNIOR_EDITOR':
            endpoint = API_ENDPOINTS.addEventForJE;
            break;
          case 'UPLOADER':
            endpoint = API_ENDPOINTS.addEventForUploader;
            break;
          default:
            throw new Error('Unsupported role for creation');
        }
        response = await postService(endpoint, payload);
      }

      // Handle response
      if (response.statusCode === 200) {
        if (isPublish) {
          if (userId && selectedRole !== 'JE' && selectedRole !== 'CE') {
            navigate('/portals/posts/viewEventsPosts');
            // showToast(
            //   'Post Updated',
            //   'success',
            //   'Your content has been successfully updated.'
            // );
          } else {
            setIsShow(true);
          }
        } else {
          setIsShow(true);
        }
      } else {
        console.error('Error saving event:', response.data);
        // showToast(response.data?.message, 'error');
      }
    } catch (error: any) {
      console.error('Error:', error);
      showToast(error?.response?.data?.message, 'error', '');
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   // if (submittedData && Array.isArray(submittedData.tagDtoList)) {
  //   //     const initialTags = submittedData.tagDtoList.map((tag: PostDto) => tag.id.toString());
  //   //     // Only set initialTags if selectedTags is empty (no need to depend on selectedTags)
  //   //     if (selectedTags.length === 0) {
  //   //       setSelectedTags(initialTags);
  //   //     }
  //   //   }
  //   if (submittedData && Array.isArray(submittedData.tagDtoList)) {
  //     const initialTags = submittedData.tagDtoList
  //       .filter((tag: TagDtoList) => tag.id != null) // Filter out null/undefined ids
  //       .map((tag: TagDtoList) => tag.id.toString());

  //     if (selectedTags.length === 0) {
  //       setSelectedTags(initialTags);
  //     }
  //   }
  // }, [submittedData, reset, setValue]);
  const handlePublish = () => {
    setIsPublish(true);
    let hasError = false;
    const plainTextContent = quillInstance.current?.getText().trim(); // Get plain text content without HTML tags
    if (!plainTextContent) {
      setContentError('Actual Content is required'); // Show error if content is empty
      hasError = true;
    } else {
      setContentError(null); // Clear content error if valid
    }
    // }
    if (!file && !submittedData?.imageDto?.documentUrl) {
      setError('imageDto', {
        type: 'manual',
        message: 'Image is required for publishing',
      });
      hasError = true;
      // return; // Stop form submission if no image is uploaded
    } else if (!selectedTags?.length) {
      setError('tagDtoList', {
        type: 'manual',
        message: 'At least one tag is required.',
      });
      hasError = true;
    } else {
      clearErrors();
    }
    if (hasError || contentError || selectedTags?.length == 0) {
      return;
    }
    handleSubmit(onSubmit);
  };
  const onSubmit: SubmitHandler<PostDto> = (data) => {
    setIsWatched(false);
    console.log(data, selectedRole);
    let hasError = false;
    // Validate the content field (Quill content) only if it's publishing
    if (isPublish) {
      const plainTextContent = quillInstance.current?.getText().trim() || ''; // Get plain text content without HTML tags
      const contentLength: number = plainTextContent?.length;
      if (!plainTextContent) {
        setContentError('Actual Content is required'); // Show error if content is empty
        return;
      } else if (contentLength < 300) {
        setContentError('Content must be at least 300 characters long.');
        return;
      } else if (contentLength > 25000) {
        setContentError('Content cannot exceed 25,000 characters.');
        return;
      } else if (!selectedTags?.length) {
        setError('tagDtoList', {
          type: 'manual',
          message: 'At least one tag is required.',
        });
        return;
        // hasError = true;
      } else if (!selectedSector) {
        setError('sector', {
          type: 'manual',
          message: 'Sector is required.',
        });
        return;
        // hasError = true;
      } else {
        setContentError(null); // Clear content error if valid
      }
    }
    if (!file && !submittedData?.imageDto?.documentUrl && isPublish) {
      setError('imageDto', {
        type: 'manual',
        message: 'Image is required.',
      });
      hasError = true; // Stop form submission if no image is uploaded
    } else {
      clearErrors();
    }
    setSubmittedData(data);
    if (selectedRole !== 'JEs') {
      handleOpenPopup();
    }
    if (hasError) {
      return;
    }
    console.log(content, 'quill content');
  };
  const handleSendForApprovals = (role: string) => {
    // Set the selected role and prepare to publish
    setSelectedRole(role);
    setIsPublish(true);

    // Validate content length
    validateContentLength(content);

    let hasError = false;

    // Validate content
    const plainTextContent = quillInstance.current?.getText().trim(); // Get plain text content without HTML tags
    if (!plainTextContent) {
      setContentError('Actual Content is required'); // Show error if content is empty
      hasError = true;
    } else {
      setContentError(null); // Clear content error if valid
    }

    // Validate image requirement
    if (userInfo?.roles === 'PUBLISHER') {
      if (
        !file &&
        !submittedData?.imageDto?.documentUrl &&
        !['VIDEO', 'INTERVIEW', 'WEBINAR'].includes(submittedData?.type || '')
      ) {
        setError('imageDto', {
          type: 'manual',
          message: 'Image is required.',
        });
        hasError = true;
      } else {
        clearErrors('imageDto');
      }
    }

    // Validate tags
    if (selectedTags?.length === 0) {
      setError('tagDtoList', {
        type: 'manual',
        message: 'At least one tag is required',
      });
      hasError = true;
    } else {
      clearErrors('tagDtoList'); // Clear error for tags when a tag is selected
    }

    // Debugging to check the final value of hasError
    console.log('Validation Status:', { hasError });

    // If there are errors, stop further actions
    if (hasError) {
      return;
    }

    // If no errors, toggle the menu
    setShowMenu((prev) => !prev);
  };
  const handleOpenPopup = () => setIsPopupOpen(true);
  const users = () => {
    navigate('/portals/posts/viewEventsPosts');
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  useEffect(() => {
    if (submittedData) {
      // Reset the form values when data is available (edit mode)
      reset({
        ...submittedData, // Prepopulate other fields
        companyName: submittedData.companyName || '', // Prepopulate companyName
      });

      // Optionally set related fields like companyId if needed
      const selectedCompany = mtCompany.find(
        (item) => item.name === submittedData.companyName
      );
      if (selectedCompany && selectedCompany.id) {
        setValue('companyId', selectedCompany.id);
      } else {
        setValue('companyName', submittedData.companyRespDto?.name || '');
        setValue('companyId', submittedData.companyRespDto?.id || '');
        setValue('recordType', submittedData.companyRespDto?.recordType || '');
      }
    }
  }, [submittedData, mtCompany, reset, setValue]);

  useEffect(() => {
    const quillElement = quillRef.current;

    const handlePaste = () => {
      // Remove this: no auto-scrolling
      // setTimeout(() => {
      //   quillElement.scrollTop = quillElement.scrollHeight;
      // }, 100);
    };

    if (quillElement) {
      quillElement.addEventListener('paste', handlePaste);
    }

    return () => {
      if (quillElement) {
        quillElement.removeEventListener('paste', handlePaste);
      }
    };
  }, []);

  const values = watch([
    'title',
    'category',
    'description',
    'eventReqDto.type',
    'eventReqDto.startDate',
    'eventReqDto.endDate',
    // "eventReqDto.mtCountryDto?.id",
  ]);

  useEffect(() => {
    const filledFields = values.filter((v) => v?.trim?.() !== '');
    const isFileFilled = file !== null;

    const totalFields = values.length + 1; // +1 for file
    const totalFilled = filledFields.length + (isFileFilled ? 1 : 0);

    setIsWatched(totalFilled > 0 && totalFilled < totalFields);
  }, [values, file]);

  console.log(isWatched);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // Check either isWatched OR if file exists
      if (isWatched) {
        event.preventDefault();
        event.returnValue = ''; // Standard for most browsers
        return ''; // For some older browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isWatched]); // Add file to dependencies

  return (
    <div className='h-full py-2 w-full'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='flex items-center mt-2 cursor-pointer justify-between  mb-4'>
          <div className='flex items-center cursor-pointer'>
            <h2
              className='mr-2 text-gray-700 font-semibold text-sm'
              onClick={users}
            >
              Events
            </h2>{' '}
            <img src='/images/arrowIcons.svg' className='mr-2' />{' '}
            <span className='text-gray-400 font-semibold text-sm'>
              {userId ? 'Edit Events' : 'Add Events'}
            </span>
          </div>
          <div className='flex items-center'>
            {/* Save as Draft button: Visible for all roles except if status is "PUBLISHED" */}
            {submittedData?.status !== 'PUBLISHED' && (
              <button
                type='button'
                className='flex items-center justify-center text-bold gap-1 py-2 px-3 rounded-lg mr-2 text-sm'
                onClick={handleSaveDraft}
              >
                Save as Draft
              </button>
            )}

            {userInfo.roles === 'PUBLISHER' && (
              <button
                className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4'
                onClick={handlePublish}
              >
                {submittedData?.status === 'PUBLISHED'
                  ? 'Re-Publish'
                  : 'Publish'}
              </button>
            )}

            {/* Conditional CTA based on role */}
            {userInfo.roles === 'CHIEF_EDITOR' ? (
              <button
                className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4'
                onClick={() => handleSendForApproval('Publisher')}
              >
                <span className='mr-2'></span>
                Send for Approval to Publisher
              </button>
            ) : userInfo.roles === 'JUNIOR_EDITOR' ? (
              // JE: Show the button to "Send for Approval"
              <div className='relative inline-block'>
                <button
                  className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4'
                  onClick={() => handleSendForApprovals('JEs')} // Toggles the menu visibility
                >
                  Send for Approval
                </button>

                {/* Dropdown menu shown only for JE */}
                {showMenu && (
                  <div
                    ref={menuRef}
                    className='absolute w-[165px] top-full left-0 bg-white shadow-md mt-1 p-3 rounded z-10'
                  >
                    <button
                      className='cursor-pointer p-2 hover:bg-gray-100 text-[14px]'
                      onClick={() => handleSendForApproval('CE')}
                    >
                      Send for Approval to Chief Editor
                    </button>
                    <button
                      className='cursor-pointer p-2 hover:bg-gray-100 text-[14px]'
                      onClick={() => handleSendForApproval('Publisher')}
                    >
                      Send to Publisher
                    </button>
                  </div>
                )}
              </div>
            ) : (
              userInfo.roles === 'UPLOADER' && (
                <div className='relative inline-block'>
                  <button
                    className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4'
                    // onClick={() => setShowMenu(!showMenu)}
                    onClick={() => handleSendForApprovals('JEs')}
                  >
                    Send for Approval
                  </button>

                  {showMenu && (
                    <div
                      ref={menuRef}
                      className='absolute w-[165px] top-full left-0 bg-white shadow-md mt-1 p-3 rounded z-10'
                    >
                      <button
                        className='cursor-pointer p-2 hover:bg-gray-100'
                        onClick={() => handleSendForApproval('CE')}
                      >
                        Chief Editor
                      </button>
                      <button
                        className='cursor-pointer p-2 hover:bg-gray-100'
                        onClick={() => handleSendForApproval('JE')}
                      >
                        Junior Editor
                      </button>
                      <button
                        className='cursor-pointer p-2 hover:bg-gray-100'
                        onClick={() => handleSendForApproval('Publisher')}
                      >
                        Publisher
                      </button>
                    </div>
                  )}
                </div>
              )
            )}
          </div>
        </div>

        <div className='flex items-center mt-2 cursor-pointer justify-between'></div>

        <div className=''>
          <div className='w-full flex gap-8'>
            <div
              className={`
    w-[65%] 
    sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 
    gap-4 
    bg-white 
    px-6 pt-6 scroolCls 
    h-[100vh]
    ${isEditorFocused ? 'overflow-y-hidden' : 'overflow-y-scroll'}
  `}
            >
              <div className='mb-3'>
                <span className='text-gray-900 font-semibold text-xl'>
                  {' '}
                  Add Event
                </span>
                <p className='text-gray-400 font-semibold text-sm'>
                  Fill the content of your events
                </p>
              </div>
              <div className='grid grid-cols-1 gap-6'>
                <InputField
                  label='Event name '
                  register={register('title', {
                    required: isPublish ? 'Event Name is required' : false,
                    // required: "Event Name is required",
                    minLength: {
                      value: 5,
                      message: 'Event name must be at least 5 characters',
                    },
                    maxLength: {
                      value: 150,
                      message: 'Event name must not exceed 150 characters',
                    },
                  })}
                  error={errors.title}
                  placement='Enter the event name'
                  required={isPublish}
                  className=''
                />

                <TeaxtArea
                  label='Short description/ Intro '
                  required={isPublish ? true : false}
                  register={register('description', {
                    required: isPublish && 'Description is required',
                    minLength: {
                      value: 100,
                      message: 'Description must be at least 100 characters',
                    },
                    maxLength: {
                      value: 500,
                      message: 'Description must not exceed 500 characters',
                    },
                  })}
                  error={errors.description}
                  placement='Enter the description'
                />
                <div className='form-group mb-4 sm:mb-0'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    {' '}
                    Event photo{' '}
                    {isPublish && (
                      <span className='font-[400]'>(Required)</span>
                    )}
                  </label>
                  <div className='relative'>
                    {!file && !submittedData?.imageDto?.documentUrl && (
                      <div className='border-dashed border-2 border-gray-300 p-6 rounded-md text-center bg-[#FF56770A]'>
                        <label className='cursor-pointer'>
                          <div className='flex justify-center mb-2'>
                            <input
                              type='file'
                              accept='image/*'
                              onChange={(e) =>
                                e.target.files &&
                                handleFileChange(e.target.files[0])
                              }
                              // onChange={handleFileChange}
                              ref={fileInputRef}
                              className=' hidden w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100'
                            />
                            <img src='/images/uploadImgIcon.svg' />
                          </div>
                          <p className='font-semibold text-sm'>
                            <span className='text-[#B00A2B]'>
                              Upload a file
                            </span>{' '}
                            <span className='text-gray-700'>
                              or drag and drop
                            </span>
                          </p>
                          <p className='text-xs text-gray-500 font-normal mt-2'>
                            Formats: PNG, JPG up to 3MB
                          </p>
                          <p className='text-xs text-gray-500 font-normal mt-1'>
                            Suggested size: 16:9 aspect ratio
                          </p>
                        </label>
                      </div>
                    )}
                    {(file || submittedData?.imageDto) && (
                      <div className='mt-1 border border-[#E7E7E7] p-4 flex items-center justify-between rounded'>
                        <div className='flex items-center'>
                          <img
                            src={
                              file
                                ? (file as string)
                                : selectedFile
                                ? URL.createObjectURL(selectedFile)
                                : submittedData?.imageDto?.documentUrl
                            }
                            alt='Preview'
                            className='max-w-xs w-[45px] h-[45px] mr-3'
                          />
                          <div>
                            <h2 className='text-[#0B0B0B] font-semibold text-xs'>
                              {selectedFile?.name
                                ? selectedFile?.name
                                : submittedData?.imageDto?.name}
                            </h2>
                            <p className='text-[#6D6D6D] text-sm font-normal'>
                              {formattedSize}
                            </p>
                          </div>
                        </div>
                        <div className='flex items-center cursor-pointer'>
                          {/* Refresh image that triggers file input */}
                          <span className='relative w-[50%] cursor-pointer'>
                            <img
                              onClick={() => fileInputRef.current?.click()}
                              // onClick={reUploadFile}
                              src='/images/refresh.svg'
                              alt='Refresh'
                              className='max-w-xs mr-3 cursor-pointer'
                            />
                            {/* Hidden file input (within the div but does not interfere with the delete image) */}
                            <input
                              type='file'
                              accept='image/*'
                              onChange={(e) =>
                                e.target.files &&
                                handleFileChange(e.target.files[0])
                              }
                              // onChange={handleFileChange}
                              ref={fileInputRef}
                              // className="hidden"
                              className='absolute top-0 left-0 w-full h-full hidden cursor-pointer'
                              // style={{ zIndex: 2 }}
                              onClick={(e) => e.stopPropagation()} // Prevent event from bubbling up to parent elements
                            />
                          </span>
                          <span className='w-[50%]'>
                            <img
                              onClick={clearFile}
                              src='/images/delete.svg'
                              alt='Delete'
                              className='max-w-xs cursor-pointer'
                            />
                          </span>
                        </div>
                      </div>
                    )}
                    {/* {errors.imageDto && (
                      <p className="text-[#B91C1C] text-normal mt-2">
                        {errors.imageDto.message}
                      </p>
                    )} */}
                  </div>
                </div>

                <InputField
                  label='Event Link'
                  register={register('eventReqDto.link', {
                    pattern: {
                      value:
                        /^(https?:\/\/)(localhost|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/,
                      message: 'Enter a valid URL',
                    },
                    // required:'Caption is required',
                  })}
                  error={errors.eventReqDto?.link}
                  placement='Enter the event link'
                  // required={isPublish ? true : false}
                  className=''
                />
                <div className='grid grid-cols-2 gap-4'>
                  <div className=' form-group'>
                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                      Start Date{' '}
                      {isPublish && (
                        <span className='font-[400]'>(Required)</span>
                      )}
                    </label>
                    <div className='flex border border-gray-300 rounded-md mt-1 form-control overflow-hidden w-[303px]'>
                      <input
                        type='date'
                        min={today}
                        onClick={handleDateClick}
                        placeholder='Enter Start Date'
                        {...register('eventReqDto.startDate', {
                          required: isPublish
                            ? 'Start date is required'
                            : false,
                          onChange: handleStartDateChange,
                        })}
                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                      />
                    </div>
                    {errors.eventReqDto?.startDate && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.eventReqDto?.startDate.message}
                      </p>
                    )}
                  </div>
                  <div className='form-group '>
                    <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                      End Date{' '}
                      {isPublish && (
                        <span className='font-[400]'>(Required)</span>
                      )}
                    </label>
                    <div className='flex border border-gray-300 rounded mt-1 form-control overflow-hidden w-[303px]'>
                      <input
                        type='date'
                        onClick={handleDateClick}
                        min={endDate}
                        placeholder='Enter End Date'
                        {...register('eventReqDto.endDate', {
                          required: isPublish ? 'End date is required' : false,
                        })}
                        className='w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none'
                      />
                    </div>
                    {errors.eventReqDto?.endDate && (
                      <p className='text-[#B91C1C] font-[500] text-sm mt-1'>
                        {errors.eventReqDto?.endDate.message}
                      </p>
                    )}
                  </div>
                </div>
                <SelectTag
                  labelName='Event Type'
                  options={eventTypeOptions}
                  required={isPublish}
                  register={register('eventReqDto.type', {
                    required: isPublish ? 'Event Type is required' : false,
                  })}
                  error={errors?.eventReqDto?.type as FieldError} // Pass `true` for required fields
                  className='mt-1'
                />
                <div className='form-group'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Event Country
                  </label>
                  <div className='relative'>
                    {/* <select
                      // value={selectedCountry || ''}
                      value={
                        selectedContry
                          ? selectedContry
                          : submittedData?.eventReqDto?.mtCountryDto?.id || ''
                      }
                      {...register(`eventReqDto.mtCountryDto.id`)}
                      onChange={(e) => handleCountryChange(e)}
                      className={`form-control border p-2 rounded mt-1 w-full custom-dropdown`}
                    >
                      <option value=''>Select country</option>
                      {mtContryData.map((item: any) => (
                        <option
                          key={item?.id}
                          value={item.id !== null ? item.id : ''}
                        >
                          {item.name}
                        </option>
                      ))}
                    </select> */}
                    <select
                      // value={selectedCountry || ''}
                      value={
                        selectedContry
                          ? selectedContry
                          : submittedData?.eventReqDto?.mtCountryDto?.id ||
                            'select'
                      }
                      {...register(`eventReqDto.mtCountryDto.id`)}
                      onChange={(e) => handleCountryChange(e)}
                      className={`form-control border p-2 rounded mt-1 w-full custom-dropdown`}
                    >
                      <option value='select'>Select country</option>
                      {mtContryData.map((item: any) => (
                        <option
                          key={item?.id}
                          value={item.id !== null ? item.id : ''}
                        >
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {selectedEventType === 'VENUE' && (
                  <TeaxtArea
                    label='Event Venue'
                    register={register('eventReqDto.venue', {
                      required:
                        selectedEventType === 'VENUE' &&
                        'Event Venue is required',
                    })}
                    error={errors?.eventReqDto?.venue}
                    placement='Enter the Event Venue'
                  />
                )}
                <div className='form-group mb-8'>
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    Actual Content{' '}
                    {isPublish && (
                      <span className='font-[400]'>(Required)</span>
                    )}
                  </label>
                  <div className='relative'>
                    <div
                      ref={quillRef}
                      className='quill-editor'
                      style={{
                        minHeight: '250px',
                        maxHeight: '450px',
                        overflowY: 'auto',
                        border: '1px solid #e0e0e0',
                        borderRadius: '6px',
                        padding: '12px',
                      }}
                    ></div>
                    {selectedImage && (
                      <div
                        className='image-toolbar absolute bg-white rounded-lg shadow-lg p-2 flex items-center gap-2 z-50'
                        style={{
                          top: `${imageToolbarPosition.top + 100}px`,
                          left: `${imageToolbarPosition.left}px`,
                        }}
                      >
                        <button
                          type='button' // Add this
                          onClick={() => alignImage('left')}
                          className='p-2 rounded hover:bg-gray-100 transition-colors'
                          title='Align Left'
                        >
                          <AlignLeft size={16} />
                        </button>
                        <button
                          type='button' // Add this
                          onClick={() => alignImage('center')}
                          className='p-2 rounded hover:bg-gray-100 transition-colors'
                          title='Align Center'
                        >
                          <AlignCenter size={16} />
                        </button>
                        <button
                          type='button' // Add this
                          onClick={() => alignImage('right')}
                          className='p-2 rounded hover:bg-gray-100 transition-colors'
                          title='Align Right'
                        >
                          <AlignRight size={16} />
                        </button>
                        <button
                          type='button' // Add this
                          onMouseDown={startResize}
                          className='p-2 rounded hover:bg-gray-100 transition-colors cursor-se-resize'
                          title='Resize'
                        >
                          <span className='bg-blue-500 text-white px-2 py-1 rounded'>
                            ⤡
                          </span>
                        </button>
                        <button
                          type='button' // Add this
                          onClick={deleteImage}
                          className='p-2 rounded hover:bg-red-100 text-red-600 transition-colors'
                          title='Delete'
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    )}
                    {contentError && (
                      <p className='text-[#B91C1C] text-normal mt-2'>
                        {contentError}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div
              className='sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 bg-white  px-6  pt-6 scroolCls h-[100vh] overflow-y-scroll'
              style={{ width: '35%' }}
            >
              <div className='mb-3'>
                <span className='text-gray-900 font-semibold text-xl'>
                  {' '}
                  Additional Information
                </span>
                <p className='text-gray-400 font-semibold text-sm'>
                  Add more information to enhance your post
                </p>
              </div>

              <div className='form-group mb-4 sm:mb-0'>
                {/* <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm flex">
                                Event Organiser{" "}
                                
                                    {isPublish && <span className="font-[400]">(Required)</span>}
                                </label> */}
                {submittedData?.companyRespDto?.recordType !== 'VENDOR' && (
                  <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                    <> Event Organiser </>
                    {isPublish && (
                      <span className='font-[400]'>(Required)</span>
                    )}
                  </label>
                )}
                {submittedData?.companyRespDto?.recordType === 'VENDOR' ? (
                  <>
                    <InputField
                      disabled
                      label='Event Organiser '
                      register={register('companyName', {})}
                      placement='Caption for image'
                      // required
                      className=''
                    />
                  </>
                ) : (
                  <div className='relative'>
                    <Controller
                      control={control}
                      name='companyName'
                      rules={{
                        required: isPublish
                          ? 'Event Organiser is required'
                          : false,
                      }}
                      render={({ field }) => (
                        // <Select
                        //   {...field}
                        //   className="w-full"
                        //   options={mtCompany.map((item) => ({
                        //     value: item.name,
                        //     label: `${item.name} (${getDisplayCompanys(item?.vendorType)})`,
                        //   }))}
                        //   value={
                        //     field.value
                        //       ? {
                        //           value: field.value,
                        //           label: `${field.value} (${getDisplayCompanys(
                        //             mtCompany.find((c) => c.name === field.value)?.vendorType
                        //           )})`,
                        //         }
                        //       : null
                        //   }
                        //   onChange={(selectedOption) => {
                        //     const selectedCompanyName = selectedOption?.value || "";
                        //     field.onChange(selectedCompanyName); // Update form value

                        //     const selectedCompany = mtCompany.find(
                        //       (item) => item.name === selectedCompanyName
                        //     );

                        //     // if (selectedCompanyName === "Internal-Free") {
                        //     //   setValue("companyId", "INTERNAL");
                        //     // } else
                        //      if (selectedCompany?.id) {
                        //       setValue("companyId", selectedCompany.id);
                        //       setValue("recordType", selectedCompany.recordType);
                        //     } else {
                        //       setValue("companyId", submittedData?.companyRespDto?.id || "INTERNAL");
                        //       setValue("recordType", submittedData?.companyRespDto?.recordType || "INTERNAL");
                        //     }
                        //   }}
                        //   onMenuScrollToBottom={handleMenuScrollToBottoms}
                        //   placeholder="Select Event Organiser"
                        //   isClearable
                        // />
                        <Select
                          {...field}
                          className='w-full'
                          options={mtCompany.map((item) => ({
                            value: item.name,
                            label: `${item.name} `,
                            recordType: item.recordType, // Include recordType for styling reference
                          }))}
                          value={
                            field.value
                              ? {
                                  value: field.value,
                                  label: `${field.value} `,
                                  recordType: mtCompany.find(
                                    (c) => c.name === field.value
                                  )?.recordType,
                                }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const selectedCompanyName =
                              selectedOption?.value || '';
                            field.onChange(selectedCompanyName);

                            const selectedCompany = mtCompany.find(
                              (item) => item.name === selectedCompanyName
                            );

                            if (selectedCompany?.id) {
                              setValue('companyId', selectedCompany.id);
                              setValue(
                                'recordType',
                                selectedCompany.recordType
                              );
                            } else {
                              setValue(
                                'companyId',
                                submittedData?.companyRespDto?.id || 'INTERNAL'
                              );
                              setValue(
                                'recordType',
                                submittedData?.companyRespDto?.recordType ||
                                  'INTERNAL'
                              );
                            }
                          }}
                          onMenuScrollToBottom={handleMenuScrollToBottoms}
                          placeholder='Select Event Organiser'
                          isClearable
                          isLoading={loading}
                          // 🎨 Custom style for options
                          styles={{
                            option: (provided, state) => {
                              const isVendor =
                                state.data.recordType === 'VENDOR';
                              return {
                                ...provided,
                                color: isVendor ? 'red' : provided.color,
                                fontWeight: isVendor ? 'bold' : 'normal',
                                backgroundColor: state.isSelected ? '#2684FF' : state.isFocused
                                  ? isVendor
                                    ? '#ffe6e6' // Light red background on hover
                                    : '#f0f0f0' // Default hover background
                                  :  'white',
                              };
                            },
                          }}
                        />
                      )}
                    />

                    {errors.companyName && (
                      <p className='text-[#B91C1C] text-normal mt-2'>
                        {errors.companyName.message}
                      </p>
                    )}
                  </div>
                )}
                {/* <div className="relative">
                                <select
                    {...register("companyName", {
                      required: isPublish ? "Company is required" : false,
                      onChange: (e) => {
                        const selectedCompanyName = e.target.value;
                        const selectedCompany = mtCompany.find(
                          (item) => item.name === selectedCompanyName
                        );
                        // Update companyId based on selected company
                        if (selectedCompany && selectedCompany.id !== null) {
                          setValue("companyId", selectedCompany.id); // Ensure id is not null
                        } else {
                          setValue("companyId", submittedData?.companyId ?  submittedData?.companyId : 0);// Fallback value if id is null (0 or other valid number)
                        }
                      },
                    })}
                    className={`form-control p-2 rounded mt-1 w-full border-gray-300 border`}
                  >
                    <option value="">Select Company</option>
                    {mtCompany.map((item: mtCompanyDto) => (
                      <option key={item.id} value={item.name || ""}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                  {errors.companyName && (
                    <p className="text-[#B91C1C] text-normal mt-2">
                      {errors.companyName.message}
                    </p>
                  )}
                                </div> */}
              </div>
              <div className='form-group mb-4 sm:mb-0'>
                <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                  Topics{' '}
                  {isPublish && <span className='font-[400]'>(Required)</span>}
                  {/* <span className="font-[400]">(Required)</span> */}
                </label>
                <Select
                  className='w-full'
                  name='leads'
                  options={mtSector
                    .filter((item) => item.id !== null) // Filter out null IDs
                    .map((item) => ({
                      value: item.id as number, // Safely assert ID is a number
                      label: item.name, // Use name as label
                    }))}
                  onMenuScrollToBottom={handleMenuScrollToBottomForSector} // Scroll handler
                  value={
                    selectedSector
                      ? {
                          value: selectedSector, // Single sector ID
                          label:
                            mtSector.find(
                              (sector) => sector.id === selectedSector
                            )?.name || '',
                        }
                      : null // Set to null if no selection
                  }
                  onChange={(selectedOption) => {
                    const selectedId = selectedOption?.value; // Get selected value
                    setSelectedSector(selectedId ?? null); // Update state with selected sector ID
                  }}
                />
              </div>
              {/* <SelectTag
                labelName="Sector"
                options={eventSectorOptions}
                register={register("sector")} // Add required validation here
                error={errors?.sector} // Pass `true` for required fields
                className="mt-1"
              /> */}

              <SelectTag
                labelName='Sector'
                required={isPublish ? true : false}
                // name={`centerReqDtos.${index}.type`}
                options={eventCategoryOptions}
                register={register(`category`, {
                  required: isPublish && 'Services Type is required',
                })}
                error={errors?.category}
                className='mt-1'
              />
              <div className='form-group mb-4 sm:mb-0'>
                <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                  Tag{' '}
                  {isPublish && <span className='font-[400]'>(Required)</span>}
                  {/* <span className="font-[400]">(Required)</span> */}
                </label>
                <div className='relative'>
                  <div className='relative'>
                    <Select
                      className='w-full'
                      isMulti
                      name='tags'
                      options={mtTag
                        .filter((item) => item.id !== null) // Filter out items with null `id`
                        .map((item) => ({
                          value: item.id!.toString(), // Use non-null assertion (!) after filtering
                          label: item.name, // Display tag name
                        }))}
                      value={selectedTags
                        .map((tagId) => {
                          const tagFound = mtTag.find(
                            (tag) => tag.id?.toString() === tagId
                          );
                          return tagFound
                            ? {
                                value: tagFound.id!.toString(), // Use non-null assertion after checking
                                label: tagFound.name,
                              }
                            : null;
                        })
                        .filter(
                          (
                            option
                          ): option is { value: string; label: string } =>
                            option !== null
                        )}
                      // onChange={(selectedOptions) => {
                      //   const selectedTagIds = selectedOptions.map((option) => option.value);
                      //   setSelectedTags(selectedTagIds); // Updates the selected tags state
                      //   clearErrors("tagDtoList");
                      // }}

                      onMenuScrollToBottom={() => {
                        handleMenuScrollToBottomForTags();
                      }} // Add your scroll handler
                      onChange={handleTagChange}
                    />
                    {errors.tagDtoList && (
                      <p className='text-[#B91C1C] text-normal mt-2'>
                        {errors.tagDtoList.message}
                      </p>
                    )}
                  </div>
                  {/* <Select
    className="w-full"
    isMulti
    name="tags"
    options={mtTag
      .filter((item) => item.id !== null) // Filter out items with null `id`
      .map((item) => ({
        value: item.id!.toString(), // Use non-null assertion (!) after filtering
        label: item.name, // Display tag name
      }))}
    value={selectedTags
      .map((tagId) => {
        const tagFound = mtTag.find(
          (tag) => tag.id?.toString() === tagId
        );
        return tagFound
          ? {
              value: tagFound.id!.toString(), // Use non-null assertion after checking
              label: tagFound.name,
            }
          : null;
      })
      .filter(
        (option): option is { value: string; label: string } =>
          option !== null
      )}
    onChange={(selectedOptions) => {
      const selectedTagIds = selectedOptions.map((option) => option.value);
      setSelectedTags(selectedTagIds); // Updates the selected tags state

      // Clear error message for tags when tags are selected
      clearErrors("tagDtoList");
    }}
    onMenuScrollToBottom={() => {
      handleMenuScrollToBottomForTags();
    }} // Add your scroll handler
  /> */}
                  {/* {errors.tagDtoList && (
    <p className="text-[#B91C1C] text-normal mt-2">
      {errors.tagDtoList.message}
    </p>
  )} */}
                </div>
              </div>
              <div className='border-b border-gray-200 mb-4 mt-4'></div>
              <div className='mb-2'>
                <span className='text-gray-900 font-semibold text-xl'>
                  {' '}
                  SEO Meta Details
                </span>
                <p className='text-gray-400 font-semibold text-sm'>
                  Fill other details of the post
                </p>
              </div>
              <InputField
                label='Meta Title'
                register={register('seoMetaTitle', {
                  minLength: {
                    value: 10,
                    message: 'Meta Title must be at least 10 characters',
                  },
                  maxLength: {
                    value: 100,
                    message: 'Meta Title must not exceed 100 characters',
                  },
                })}
                error={errors.seoMetaTitle}
                placement='Enter your meta title'
                className=''
              />
              <TeaxtArea
                label='Meta Description'
                register={register('seoDescription', {
                  minLength: {
                    value: 50,
                    message: 'Meta Description must be at least 50 characters',
                  },
                  maxLength: {
                    value: 200,
                    message: 'Meta Description must not exceed 200 characters',
                  },
                })}
                error={errors.seoDescription}
                placement='Enter the Meta Description'
              />
              <div className='form-group mb-4 sm:mb-0'>
                <label className='mb-1 ml-1 font-semibold text-gray-700 text-sm'>
                  Keywords
                </label>
                <div className='relative'>
                  {/* Display added keywords */}
                  <div className='flex flex-wrap'>
                    {assignToSubUsers.map((tag, index) => (
                      <span
                        key={index}
                        className='flex items-center bg-blue-200 text-blue-800 rounded-lg px-2 py-1 mr-2 mb-2'
                      >
                        {tag}
                        <button
                          type='button'
                          onClick={() => removeKeyword(tag)}
                          className='ml-1 text-blue-800 hover:text-blue-600'
                          aria-label={`Remove ${tag}`}
                        >
                          &times;
                        </button>
                      </span>
                    ))}
                  </div>

                  {/* Input for adding new keywords */}
                  <textarea
                    placeholder='Enter keywords, separated by commas'
                    rows={3}
                    value={keywordsInput} // Controlled input
                    onChange={(e) => setKeywordsInput(e.target.value)} // Handle input change
                    onKeyDown={addKeyword} // Handle Enter or comma key
                    className='border mt-1 p-2 rounded w-full'
                  ></textarea>
                  {errors.keyWords && (
                    <span className='text-[#B91C1C]'>
                      {errors.keyWords.message}
                    </span>
                  )}
                </div>
              </div>
              <TeaxtArea
                label='Keyphrases'
                register={register('seoAltText', {
                  minLength: {
                    value: 10,
                    message: 'Keyphrases must be at least 10 characters',
                  },
                  maxLength: {
                    value: 125,
                    message: 'Keyphrases must not exceed 125 characters',
                  },
                })}
                error={errors.seoAltText}
                placement='Enter your Keyphrases'
              />
            </div>
          </div>
        </div>
      </form>
      {isPopupOpen && (
        <AddEventConfirmationModal
          onClose={handleClosePopup}
          onConfirm={handleConfirm}
          isUpdate={userId ? 'update' : 'submit'}
          isApproval={isPublish ? 'approval' : 'draft'}
          statusValue={submittedData?.status || ''}
          role={selectedRole || ''}
        />
      )}
      {isShow && (
        <Sucesspopup
          addUser={closePopup}
          viewUser={viewUsers}
          emailId={''}
          isUpdate={userId ? 'update' : 'add'}
          nameOfScreen='posts'
          isEvent='events'
          isApproval={isPublish ? 'approval' : 'draft'}
          statusValue={submittedData?.status || ''}
          role={selectedRole || ''}
          download={function (): void {
            throw new Error('Function not implemented.');
          }}
          upload={function (): void {
            throw new Error('Function not implemented.');
          }}
          confirm={function (): void {
            throw new Error('Function not implemented.');
          }}
        />
      )}
    </div>
  );
}

export default AddEvents;
